import { z } from 'zod';
export const uuidSchema = z.string().uuid();
/** Calendar date `YYYY-MM-DD` (no time zone). */
export const isoDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'Expected YYYY-MM-DD')
    .refine((s) => !Number.isNaN(Date.parse(`${s}T00:00:00Z`)), 'Invalid calendar date');
/** RFC 3339 instant. */
export const instantSchema = z.string().datetime({ offset: true });
/** IANA time zone name, validated with the runtime's Intl database. */
export const timeZoneSchema = z.string().refine((tz) => {
    try {
        new Intl.DateTimeFormat('en-US', { timeZone: tz });
        return true;
    }
    catch {
        return false;
    }
}, { message: 'Unknown IANA time zone' });
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    pageSize: z.coerce.number().int().min(1).max(200).default(50),
});
export const paginationMetaSchema = z.object({
    page: z.number().int(),
    pageSize: z.number().int(),
    total: z.number().int(),
    totalPages: z.number().int(),
});
export function paginated(item) {
    return z.object({ data: z.array(item), meta: paginationMetaSchema });
}
/** `?sort=lastName:asc,createdAt:desc` → [{ field, direction }] restricted to `allowed`. */
export function sortQuerySchema(allowed) {
    const field = z.enum(allowed);
    const fallback = { field: allowed[0], direction: 'asc' };
    return z
        .string()
        .optional()
        .transform((raw, ctx) => {
        if (!raw)
            return [];
        return raw.split(',').map((part) => {
            const [f, d = 'asc'] = part.split(':');
            const parsedField = field.safeParse(f);
            if (!parsedField.success || (d !== 'asc' && d !== 'desc')) {
                ctx.addIssue({ code: z.ZodIssueCode.custom, message: `Invalid sort segment: ${part}` });
                return fallback;
            }
            return { field: parsedField.data, direction: d };
        });
    });
}
export const problemDetailsSchema = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    code: z.string(),
    detail: z.string().optional(),
    errors: z.array(z.object({ path: z.string(), message: z.string() })).optional(),
    requestId: z.string().optional(),
});
//# sourceMappingURL=common.js.map